import React, { useState, useRef, useEffect } from "react";
import * as XLSX from "xlsx";
import { Trash2 } from "lucide-react";
import axios from "axios";

const MultiUnitsTable = ({
  setMultiUnitsEntries,
  multiUnitsEntries,
  onEntriesChange,
  unitsListFromAPI,
  formData,
  isEdit,
}) => {



  const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
  
  const [selectAll, setSelectAll] = useState(false);
  console.log("unitsListFromAPI:", unitsListFromAPI);
  const toggleSelectAll = (checked) => {
    setSelectAll(checked);
    const newRows = multiUnitsEntries.map((r) => ({ ...r, selected: checked }));
    onEntriesChange(newRows);
  };

  const toggleRow = (idx, checked) => {
    const newRows = [...multiUnitsEntries];
    newRows[idx].selected = checked;
    onEntriesChange(newRows);
  };

  const updateCell = (idx, field, value) => {
    const newRows = [...multiUnitsEntries];
    newRows[idx][field] = value;
    // onEntriesChange(newRows);
    setMultiUnitsEntries(newRows);
  };

  const addRow = () => {
    console.log("add row");
    const newRow = {
      units: "", // correct field for UNIT
      partNumber: "", // correct field for FRAC
      quantity: "", // correct field for PRICE
      selected: false,
    };

    // onEntriesChange([...multiUnitsEntries, newRow]);
    setMultiUnitsEntries([...multiUnitsEntries, newRow]);
  };

  const deleteSelected = () => {
    // onEntriesChange(multiUnitsEntries.filter((r) => !r.selected));
    setMultiUnitsEntries(multiUnitsEntries.filter((r) => !r.selected));
  };

  const fileInputRef = useRef(null);

  const handleImport = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target?.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });

      const imported = rows.slice(1).map((r) => ({
        oemBrand: r[0] ?? "",
        partNumber: r[1] ?? "",
        quantity: r[2] ?? "",
        selected: false,
      }));

      onEntriesChange([...multiUnitsEntries, ...imported]);
    };
    reader.readAsBinaryString(file);

    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  useEffect(() => {
    if (formData.code && formData.code.length > 0) {
      fetchMultiUnitsData();
    }
  }, [isEdit]);

  const fetchMultiUnitsData = async () => {
    try {
      const apiPaths = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : null;

      const apiBaseURL = apiPaths?.[0]?.API_CONFIG;
      const companyCode = localStorage.getItem("companyCode");
      const itemCode = formData.code || "-";

      if (!apiBaseURL) {
        console.error("API Base URL missing in local storage");
        return;
      }

      const apiURL = `${apiBaseURL}/api/CpaysCount/${companyCode}/UNITS/${itemCode}/-`;

      const response = await axios.get(apiURL);

      console.log("Multi Units Retreival Data:", response.data);
      setMultiUnitsEntries(
        response.data.map((row) => ({
          unit: row.Unit ?? "",
          partNumber: row.Frac ?? "",
          quantity: row.price ?? "",
          selected: false,
        }))
      );
    } catch (error) {
      console.error("Error while fetching multi units Data:", error);
    }
  };

  const buildMultiUnitsPayload = () => {


    console.log("multiUnitsEntries:", multiUnitsEntries);
    return multiUnitsEntries.map((row) => ({
      
      CmpCode: COMPANY_CODE,
      mode: "ENTRY",

      CODE: formData.code,
      UNIT: row.unit || "",
      FRAC: Number(row.partNumber) || 0,
      PRICE: Number(row.quantity) || 0,
      bu: "",
      BARCODE: "",
    }));
  };

  const saveMultiUnits = async () => {
    const moreUnitsPayload = buildMultiUnitsPayload();

    if (moreUnitsPayload.length > 0) {
      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
      const apiMultiURL = `${apiBaseURL}/api/CRMMoreUnitsReg`;
      const unitsResponse = await axios.post(apiMultiURL, moreUnitsPayload, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("MULTI UNITS SAVED:", unitsResponse.data);
    }
  };

  return (
    <div className="mt-6 ">
      <div className="h-[400px] bg-white  overflow-auto  rounded-md shadow-sm border border-gray-200">
        <table className="text-sm bg-white  w-full ">
          <thead className="bg-gray-100 sticky top-0 z-20">
            <tr className="h-10">
              <th className="border px-2 py-1 text-center ">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={(e) => toggleSelectAll(e.target.checked)}
                  className="w-5 h-5 rounded border-gray-400 cursor-pointer"
                />
              </th>

              <th className="border px-2 py-1 font-normal">Unit</th>
              <th className="border px-2 py-1 font-normal">Fraction</th>
              <th className="border px-2 py-1 font-normal">Price</th>
            </tr>
          </thead>

          <tbody
            className={`divide-y divide-gray-200 bg-white ${
              multiUnitsEntries?.length === 0
                ? "border-none"
                : "border border-gray-300"
            } `}
          >
            {multiUnitsEntries?.length === 0 ? (
              <tr className="">
                <td colSpan={8} className=" text-center py-8 text-gray-500">
                  No parts added yet.
                </td>
              </tr>
            ) : (
              multiUnitsEntries?.map((row, idx) => (
                <tr key={idx} className="border border-gray-300">
                  {/* Checkbox */}
                  <td className="border-x px-2 text-center">
                    <input
                      type="checkbox"
                      checked={row.selected ?? false}
                      onChange={(e) => toggleRow(idx, e.target.checked)}
                      className="w-4 h-4 rounded border-gray-400 cursor-pointer"
                    />
                  </td>

                  {/* Unit */}
                  <td className="border-x p-1">
                    {/* <input
                // type="text"
                value={row.oemBrand ?? ""}
                onChange={(e) => updateCell(idx, "oemBrand", e.target.value)}
                placeholder="Unit"
                className="w-full px-2 text-sm border-none focus:outline-none focus:ring-1 focus:ring-blue-400 rounded"
              /> */}
                    <select
                      value={row.unit || ""}
                      onChange={(e) => updateCell(idx, "unit", e.target.value)}
                      className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                    >
                      <option value="">Pick from List</option>
                      {unitsListFromAPI?.map((group) => (
                        <option key={group.UNIT} value={group.UNIT}>
                          {group.UNIT}
                        </option>
                      ))}
                    </select>
                  </td>

                  {/* Part Number */}
                  <td className="border-x p-1">
                    <input
                      // type="text"
                      value={row.partNumber ?? ""}
                      onChange={(e) =>
                        updateCell(idx, "partNumber", e.target.value)
                      }
                      placeholder="Fraction"
                      className="w-full  px-2 text-sm border-none focus:outline-none focus:ring-1 focus:ring-blue-400 rounded"
                    />
                  </td>

                  {/* Quantity */}
                  <td className="border-x p-1">
                    <input
                      type="number"
                      value={row.quantity ?? ""}
                      onChange={(e) =>
                        updateCell(idx, "quantity", e.target.value)
                      }
                      placeholder="0"
                      className="w-full  px-2 text-sm border-none text-right focus:outline-none focus:ring-1 focus:ring-blue-400 rounded"
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center mt-4">
        <button
          onClick={addRow}
          className="px-2 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
        >
          + Add
        </button>
        {/* <button
          onClick={saveMultiUnits}
          className="px-2 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
        >
          Save
        </button> */}

        {multiUnitsEntries?.some((r) => r.selected) && (
          <button
            onClick={deleteSelected}
            className="px-2 py-1 bg-red-600 text-white text-sm rounded hover:bg-red-700 flex items-center"
          >
            <Trash2 className="w-3 h-4 mr-2" />
            Delete
          </button>
        )}

        <label className="cursor-pointer">
          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls"
            onChange={handleImport}
            className="hidden"
          />
          <span className="px-2 py-1 bg-green-600 text-white text-sm rounded hover:bg-green-700 inline-block">
            Import
          </span>
        </label>
      </div>
    </div>
  );
};

export default MultiUnitsTable;
